import { createApp } from 'vue'
import LocalFavoritesCityPicker from './LocalFavoritesCityPicker.vue'

export { default as LocalFavoritesCityPicker } from './LocalFavoritesCityPicker.vue'

// Mounted client-side rather than SSR'd: the module sits below the fold, and the
// picker is the last thing in its header row, so arriving late shifts nothing.
export function setupLocalFavoritesCityPicker (el: HTMLElement, props: Record<string, unknown>) {
  createApp(LocalFavoritesCityPicker, props).mount(el)
}
